import { useState } from 'react';

import ForgotPasswordForm from '@/components/Auth/ForgotPasswordForm';
import { useIsUserInitialized, useUser } from '@/providers/Auth';

import SignInForm from '../SignInForm/SignInForm';
import SignUpForm from '../SignUpForm/SignUpForm';
import { type View } from '../types';

type Props = {
  creatorSlug?: string;
  defaultView?: View | null;
  initialSignInMethod?: 'phone' | 'email';
  phoneNumber?: string;
  email?: string;
  name?: string;
  isCreatorView?: boolean;
};

const EmbeddedAuthForm: React.FC<Props> = ({
  creatorSlug,
  defaultView,
  initialSignInMethod,
  phoneNumber,
  email,
  name,
  isCreatorView = false,
}) => {
  const [view, setView] = useState<View>(defaultView || 'signIn');
  const [user] = useUser();
  const isUserInitialized = useIsUserInitialized();

  const [userEmail, setUserEmail] = useState('');

  const handleChangeView = (newView: View, data?: { email: string }): void => {
    if (newView === 'forgotPassword') {
      setUserEmail(data?.email || '');
    }
    setView(newView);
  };

  if (!isUserInitialized) {
    return null;
  }

  if (user && !user.isAnonymous) {
    // Should be functionally unreachable.
    return null;
  }

  if (view === 'signUp') {
    return (
      <SignUpForm
        activationEmail={email}
        activationName={name}
        creatorSlug={creatorSlug}
        onChangeView={handleChangeView}
        isCreatorView={isCreatorView}
      />
    );
  }

  if (view === 'forgotPassword') {
    return <ForgotPasswordForm creatorSlug={creatorSlug} userEmail={userEmail} onChangeView={handleChangeView} />;
  }

  if (view === 'signIn') {
    return (
      <SignInForm
        creatorSlug={creatorSlug}
        onChangeView={handleChangeView}
        initialAuthMethod={initialSignInMethod}
        phoneNumber={phoneNumber}
        email={email}
        isCreatorView={isCreatorView}
      />
    );
  }

  // Should be functionally unreachable.
  return null;
};

export default EmbeddedAuthForm;
export type { View };
